import React, {useCallback, useMemo, useState} from "react";
import {FormControl, InputGroup} from "react-bootstrap";
import {queryStringToHash, updateQueryString} from "./lib/utils";
import {useUpdateEffect} from './lib/customHooks';
import debounce from 'lodash/debounce';

const style = Object.freeze({maxWidth: 200});

export const rejectEmptyValue = obj =>
    Object.keys(obj)
        .filter(k => obj[k] !== undefined)
        .reduce((acc, k) => ({...acc, [k]: obj[k]}), {});

const defaultIndex = (list, order, direction, value) => {
    const defaultIdx = list.findIndex(row => `${row.value}` === `${value}`);
    if (defaultIdx) return defaultIdx;
    const idx = list.findIndex(row => (row.order === order) && (row.direction === direction));
    return idx === -1 ? 0 : idx;
};

const SearchSelect = props => {
    console.log('pp', props);
    const list = useMemo(() => JSON.parse(props.list), [props.list]);
    const [index, setIndex] = useState(defaultIndex(list, props.order, props.direction, props.value));
    const [jqxhr, setJqxhr] = useState(null);

    const fetch = useCallback(debounce((q) => {
        if (jqxhr) {
            jqxhr.abort();
        }

        updateQueryString(rejectEmptyValue(q))

        const options = {
            type: 'GET',
            url: props.url,
            data: {...queryStringToHash(), ...rejectEmptyValue(q)}
        };
        setJqxhr($.ajax(options));
    }, 500), [jqxhr]);

    const handleChange = e => {
        e.persist();
        setIndex(e.target.value);
    };

    useUpdateEffect(() => fetch({[props.name]: list[index].value}), [index]);



    return (
        <InputGroup className="align-items-center">
            <InputGroup.Text>{props.label}</InputGroup.Text>
            <FormControl
                as="select"
                style={style}
                value={index}
                onChange={handleChange}>
                {list.map((row, idx) =>
                    <option key={idx} value={idx}>{row.label}</option>
                )}
            </FormControl>
        </InputGroup>
    );
}

export default SearchSelect;
